module.exports = __webpack_public_path__ + "static/media/Aaron Lu.a0d010b8.png";